module.exports = __webpack_public_path__ + "img/Power Apps.b0fff848.svg";